import {
  isFieldLengthValid,
  isWebsiteUrlValid,
  isRequiredFieldValid,
  containsEmoji,
  getMaxLengthErrorMessage,
  getRequiredFieldErrorMessage,
  getEmojiErrorMessage,
  getInvalidEmailErrorMessage,
  getDuplicateEmailErrorMessage,
  getInvalidPhoneErrorMessage,
  getInvalidUrlErrorMessage,
} from '../PyFormValidations';
import { isValidEmail } from 'utils/isValidEmail';
import { hasValidPhoneCharacters } from 'components/editor/helpers/InputValidation';
import type { ContactsControllerCreateContactMutationRequest } from '@proposify/document-service-api-schema';

export { normalizeWebsiteUrl } from '../PyFormValidations';

export const REQUIRED_FIELDS = ['firstName', 'lastName', 'email'];
const TEXT_FIELDS = ['firstName', 'lastName', 'title'];

export const validateField = (field: string, value: string, t: (key: string) => string, existingEmails: string[] = []) => {
  const trimmed = value.trim();

  if (REQUIRED_FIELDS.includes(field) && !isRequiredFieldValid(trimmed)) {
    return { error: getRequiredFieldErrorMessage(t) };
  }

  if (TEXT_FIELDS.includes(field) && trimmed && containsEmoji(trimmed)) {
    return { error: getEmojiErrorMessage(t) };
  }

  if (field === 'email' && trimmed) {
    if (!isValidEmail(trimmed)) return { error: getInvalidEmailErrorMessage(t) };
    if (existingEmails.includes(trimmed.toLowerCase())) return { error: getDuplicateEmailErrorMessage(t) };
  }

  if ((field === 'mobileNo' || field === 'officeNo') && trimmed && !hasValidPhoneCharacters(trimmed)) {
    return { error: getInvalidPhoneErrorMessage(t) };
  }

  if (field === 'websiteUrl' && trimmed && !isWebsiteUrlValid(trimmed)) {
    return { error: getInvalidUrlErrorMessage(t) };
  }

  if (!isFieldLengthValid(value)) {
    return { error: getMaxLengthErrorMessage(t) };
  }

  return { error: '' };
};

export const isFormValid = (values: Record<string, string>, hasErrors: boolean): boolean =>
  REQUIRED_FIELDS.every((field) => isRequiredFieldValid(values[field] || '')) && !hasErrors;

export const mapToRequest = (
  formValues: Record<string, string>,
  companies: ContactsControllerCreateContactMutationRequest['companies'],
  useCompanyAddress = false
): ContactsControllerCreateContactMutationRequest => ({
  companies,
  firstName: formValues.firstName,
  lastName: formValues.lastName,
  email: formValues.email,
  title: formValues.title?.trim() || undefined,
  mobileNo: formValues.mobileNo?.trim() || undefined,
  officeNo: formValues.officeNo?.trim() || undefined,
  websiteUrl: formValues.websiteUrl?.trim() || undefined,
  useCompanyAddress,
  address1: formValues.address1?.trim() || undefined,
  address2: formValues.address2?.trim() || undefined,
  city: formValues.city?.trim() || undefined,
  zipCode: formValues.zipCode?.trim() || undefined,
  countryId: formValues.countryId ? Number(formValues.countryId) : undefined,
  stateId: formValues.stateId ? Number(formValues.stateId) : undefined,
});
